<template>
    <div class="z-nav-item">
        <button v-b-tooltip.hover="{customClass: 'opacity-100' }" title="Show Download Options" class="btn" v-bind:class="'btn-'+variant" v-on:click="showDownloadDialog()" v-if="viz"><b-icon-download></b-icon-download></button>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import store from '../store/store';
import { BIconDownload } from 'bootstrap-vue';
/**
 * Component displays button taht invoke Tableau download dialog.
 * @tag z-nav-download-dialog-button
 */
export default {
    name:'NavDownloadDialogButton',
    store,
    components: {
        BIconDownload,
    },
    props: {
        /**
         * Bootstrap button variant.
         * @example variant="primary"
         * @values primary, secondary, success, danger, warning, info, light, dark, link
         */
        variant: {
            type: String,
            default: 'primary'
        }
    },
    computed: {
        ...mapState('viz', [ 'viz' ]),
    },
    methods: {
        ...mapActions('viz', [
            'showDownloadDialog'
        ]),
    },
};
</script>

<style>
.opacity-100{
    opacity: 1;
}
</style>
